"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.precompile04 = void 0;
const util_1 = require("@ethereumjs/util");
const evm_1 = require("../evm");
function precompile04(opts) {
    const data = opts.data;
    let gasUsed = opts._common.param('gasPrices', 'identity');
    gasUsed += opts._common.param('gasPrices', 'identityWord') * BigInt(Math.ceil(data.length / 32));
    if (opts._debug) {
        opts._debug(`Run IDENTITY (0x04) precompile data=${(0, util_1.short)(opts.data)} length=${opts.data.length} gasLimit=${opts.gasLimit} gasUsed=${gasUsed}`);
    }
    if (opts.gasLimit < gasUsed) {
        if (opts._debug) {
            opts._debug(`IDENTITY (0x04) failed: OOG`);
        }
        return (0, evm_1.OOGResult)(opts.gasLimit);
    }
    if (opts._debug) {
        opts._debug(`IDENTITY (0x04) return data=${(0, util_1.short)(opts.data)}`);
    }
    return {
        executionGasUsed: gasUsed,
        returnValue: Buffer.from(data), // Copy the memory (`Buffer.from()`)
    };
}
exports.precompile04 = precompile04;
//# sourceMappingURL=04-identity.js.map